import { metric } from '../metric';
import { logError } from '../logError';

type Params<F extends (...args: any[]) => any> = F extends (...args: infer A) => any ? A : never;

export const apiHandler =
    <F extends (...args: any[]) => any>(handler: F, graph: string) =>
    async (...args: Params<F>): Promise<Awaited<ReturnType<F>>> => {
        const start = Date.now();
        try {
            const resp = await handler(...args);
            metric.time(`external_calls.${graph}.success`, Date.now() - start);
            return resp;
        } catch (error) {
            metric.time(`external_calls.${graph}.error`, Date.now() - start);
            logError(error);
            throw error;
        }
    };
